module.exports = __webpack_public_path__ + "static/media/jordan.2df29a3f.svg";